<template>
  <div class="gf-user-avatar-cropper">
    <gf-image-cropper
      v-if="currentAvatar"
      :selected-image-source="currentAvatar"
      preview-width="120px"
      :is-rounded-crop="true"
      input-name="avatar"
      @setDefault="setDefaultAvatar"
    />
  </div>
</template>

<script>
import UserService from '@shared/services/user.service';
import GfImageCropper from './GfImageCropper.vue';

export default {
  name: 'GfUserAvatarCropper',
  components: { GfImageCropper },
  props: {
    currentAvatar: {
      type: String
    },
    isAdminVersion: {
      type: Boolean,
      default: false
    },
    userUuid: {
      type: String
    }
  },
  methods: {
    setDefaultAvatar() {
      const setUserAvatar = this.isAdminVersion
        ? UserService.setUserDefaultAvatarAdmin(this.userUuid)
        : UserService.setDefaultAvatar();

      setUserAvatar.then(() => {
        window.location.reload();
      });
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-user-avatar-cropper';

#{$this} {
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;

  @include theme.sm {
    top: 40px;
    left: 40px;
    transform: none;
    bottom: auto;
  }
}
</style>
